interface SchemaOrgProps {
  type: "Organization" | "WebSite" | "WebPage" | "BreadcrumbList" | "Article" | "FAQPage";
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const getSchema = () => {
    const base = { "@context": "https://schema.org", "@type": type, ...data };
    return JSON.stringify(base);
  };

  return (
    <script
  type="application/ld+json"
  dangerouslySetInnerHTML={{ __html: getSchema() }}
    />
  );
}